import { FEATURE_NAME } from './constants';
import { createSlice } from '@reduxjs/toolkit';
import * as T from './types';
import * as actions from './actions';

const initialState: T.WidgetState = {
  data: null,
  error: null,
  loading: false,
};

export const widgetsSlice = createSlice({
  name: FEATURE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(actions.fetchWidgetData.fulfilled, (state, action) => {
      state.data = action.payload.data;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(actions.fetchWidgetData.rejected, (state, action) => {
      state.data = null;
      state.loading = false;
      state.error = action.error.message;
    });
    builder.addCase(actions.fetchWidgetData.pending, (state) => {
      state.data = null;
      state.loading = true;
      state.error = null;
    });
  },
});
